import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import api from "../Api";
import TableFooter from "../components/TableFooter";
import DeleteModal from "../components/DeleteModal";
import { Link } from "react-router-dom";
import Popup from "../components/PopUP";
import ActivateModal from "../components/ActivateModal";
import DeactivateModal from "../components/DeactivateModal";
import { useNavigate } from "react-router-dom";
import { IMAGE_URL } from "../utils/constants";


export default function Manufactuer() {
  const [manufacturers, setManufacturer] = useState({})
  const [loading, setLoading] = useState(true);
  const [popupMessage, setPopupMessage] = useState("");

  const [pagination, setPagination] = useState({
    count: 0,
    total_pages: 0,
    next: 0,
    previous: 0
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("")

  useEffect(() => {
    if (popupMessage === "") {
      if (loading === false) {
        setPopupMessage("Manufacturer loaded successfully")
      }
      else {
        setPopupMessage("Manufacturer loading  please wait ...")
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/airplane-service/manufacturer/?page=" + currentPage + "&q=" + query);
        console.log("API Response:", response.data);
        setManufacturer(response.data)
        setPagination({
          count: response.data.count,
          total_pages: response.data.total_pages,
          next: response.data.next,
          previous: response.data.previous
        });
      } catch (error) {
        console.error("API Error:", error.message);
      }
      setLoading(false)
    };

    fetchData();
  }, [currentPage, query, loading])

  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showActiveModal, setActiveShowModal] = useState(false);
  const [showDeactiveModal, setDeactiveShowModal] = useState(false);


  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleConfirmDelete = async () => {
    console.log("Deleting:", selectedItem.name);
    setLoading(false);
    try {
      const response = await api.delete('/airplane-service/manufacturer/' + selectedItem.manufacturer_id)
      console.log("Activation response:", response.data);
      setPopupMessage(response.data.detail || "Manufacturer deleted successfully")
      setSelectedItem(null);
    }
    catch (error) {
      console.log("Activation error:", error);
      setPopupMessage("An error occurred during deleting")
      return;
    }
    setActiveShowModal(false);
    setLoading(true);
  };

  const handleActivateClick = (item) => {
    console.log("actove:", item);
    setSelectedItem(item);
    setActiveShowModal(true);
  };

  // Activate manufacturer
  const handleConfirmActivation = async () => {
    console.log("activating:", selectedItem.manufacturer_id);
    setLoading(false);
    try {
      const response = await api.patch('/airplane-service/manufacturer/status', { "manufacturer_id": selectedItem.manufacturer_id, "action": "activate" })
      console.log("Activation response:", response.data);
      setPopupMessage(response.data.details || "Manufacturer activated successfully")
    }
    catch (error) {
      console.log("Activation error:", error);
      setPopupMessage("An error occurred during activation")
      return;
    }
    setActiveShowModal(false);
    setSelectedItem(null);
    setLoading(true);
  };

  const handleDeactivateClick = (item) => {
    console.log("Item to delete:", item);
    setSelectedItem(item);
    setDeactiveShowModal(true);
  };

  // Deactivate manufacturer
  const handleConfirmDeactivateClick = async () => {
    console.log("deactivating:", selectedItem.manufacturer_id);
    setLoading(false);
    try {
      const response = await api.patch('/airplane-service/manufacturer/status', { "manufacturer_id": selectedItem.manufacturer_id, "action": "deactivate" })
      console.log("Activation response:", response.data);
      setPopupMessage(response.data.details || "Manufacturer deactivated successfully")
    }
    catch (error) {
      console.log("Activation error:", error);
      setPopupMessage("An error occurred during activation")
      return;
    }
    setDeactiveShowModal(false);
    setSelectedItem(null);
    setLoading(true);
  };

  //  manufacture details
  const navigate = useNavigate();
  const goToManufafureDetail = (id) => {
    navigate(`/manufacturer/${id}`);
  };


  return (
    <div className="user-management-page">
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      {/* Sidebar */}
      <Sidebar />

      {/* Main Wrapper */}
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Content Section */}
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <h1>Manufacturer Management</h1>
                      </div>
                      <div className="d-flex flex-end">
                        <Link to="/manufacturer-create" className="secondary_btn">+ Add Manufacturer</Link>
                      </div>
                    </div>
                  </div>

                  {/* Table */}
                  {loading ?
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                    :
                    <div className="common-table-wrapper mt-4">
                      <div className="common-table-filter-wrapper">
                        <div className="common-left-blk">
                          <div className="common_sub_heading_wrapper mb-0">
                            <h2>Manufacturers Listing</h2>
                          </div>
                        </div>
                        <div className="common-right-blk">
                          <div className="common-sort-blk">
                            <div className="common-search-blk">
                              <input type="search" className="form-control" id="search" placeholder="Search" value={query} onChange={(e) => setQuery(e.target.value)} name="manufacturer_search" />
                            </div>
                          </div>
                          <Link to='/upload-manufacturers' className="secondary_btn">Upload CSV</Link>
                        </div>
                      </div>

                      <div className="table-blk table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>S.No.</th>
                              <th>Manufacturer Name</th>
                              <th>Logo</th>
                              <th>Status</th>
                              {/* <th>Updated At</th> */}
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {manufacturers.results && manufacturers.results.map((mfr, index) => (
                              <tr key={mfr.id}>
                                <td>{(index + 1) + (currentPage - 1) * 20}</td>
                                <td className="text-capitalize">
                                  {mfr.company_name}
                                </td>
                                <td className="td_img_preview">
                                  <div>
                                    <img src={mfr.logo} alt="Manufacturer logo" className="table_img"></img>
                                  </div>
                                </td>
                                <td>{mfr.is_active ? <span className="badge bg-light text-success">Active</span> :
                                  <span className="badge bg-light text-danger">Deactivate</span>}</td>
                                {/* <td></td> */}
                                <td className="">
                                  <button onClick={() => goToManufafureDetail(mfr.id)} className="border-0 bg-white">
                                    <img src={IMAGE_URL + "eye-tbl-icon.svg"} alt="View" />
                                  </button>
                                  <button onClick={() => navigate(`/manufacturer/update/${mfr.id}`)} className="border-0 bg-white ms-1">
                                    <img src={IMAGE_URL + "edit-icon.svg"} alt="Edit" />
                                  </button>
                                  {mfr.is_active ?
                                    <button
                                      className="border-0 bg-white"
                                      onClick={() => handleDeactivateClick({ "manufacturer_id": mfr.id, "name": mfr.company_name })}
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" className="bi bi-toggle-off ms-1"
                                        viewBox="0 0 16 16">
                                        <path
                                          d="M11 4a4 4 0 0 1 0 8H8a5 5 0 0 0 2-4 5 5 0 0 0-2-4zm-6 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8M0 8a5 5 0 0 0 5 5h6a5
                                           5 0 0 0 0-10H5a5 5 0 0 0-5 5"/>
                                      </svg>
                                    </button>
                                    :
                                    <button
                                      className="border-0 bg-white ms-1"
                                      onClick={() => handleActivateClick({ "manufacturer_id": mfr.id, "name": mfr.company_name })}
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg"
                                        width="26" height="26" fill="currentColor" class="bi bi-toggle-on"
                                        viewBox="0 0 16 16">
                                        <path d="M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8" />
                                      </svg>
                                    </button>
                                  }
                                  <button
                                    className="border-0 bg-white"
                                    onClick={() => handleDeleteClick({ "manufacturer_id": mfr.id, "name": mfr.company_name })}
                                  >
                                    <img src={IMAGE_URL + "trash-icon.svg"} alt="Trash" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* footer */}
                      <TableFooter
                        pagination={pagination}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                      {/*  */}
                    </div>
                  }
                  {/* Table End */}

                  {/* Delete Modal */}
                  <DeleteModal
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    onConfirm={handleConfirmDelete}
                    itemName={selectedItem ? selectedItem.name : ""}
                  />
                  <ActivateModal
                    show={showActiveModal}
                    onClose={() => setActiveShowModal(false)}
                    onConfirm={handleConfirmActivation}
                    itemName={selectedItem ? selectedItem.name : ""}
                  />

                  <DeactivateModal
                    show={showDeactiveModal}
                    onClose={() => setDeactiveShowModal(false)}
                    onConfirm={handleConfirmDeactivateClick}
                    itemName={selectedItem ? selectedItem.name : ""}
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}


